import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-28",
  "use": "icon-button_icon-28-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-28\"><path d=\"M14.635 1.945L5.798 14.092h5.523l-1.06 7.853L18.936 9.76h-5.308z\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol